/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 22:10:31
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-08 09:41:12
 * @Description: 活动微信jssdk服务 
 * https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html
 */
import wx from "weixin-js-sdk";
import request from "@/http/common"
import apiActWxauth from "@/api/act-wxauth";
import {  MessageBox,Indicator } from "mint-ui";
import util from "@/utils/common";
import Vue from 'vue/dist/vue.js';
import { handlerYqAnalyticsEvent } from "@/utils/biz";
import apizt from "@/api/act-logic-zouteng";
import httpzt from "@/http/act-logic-zouteng";

let shareTitle = '';
let shareDesc = '';
let shareLink = '';
let shareImgUrl = '';
let shareType = 'link';
let shareDataUrl = '';
let currentIsInMiniProgram = undefined;
let jssdkObj={}
/**
 * 设置分享
 * @param {string} title 分享标题
 * @param {string} desc 分享描述
 * @param {string} link 分享链接
 * @param {string} imgUrl 分享小图url
 */
function setShare(title, desc, link, imgUrl) {
  shareTitle = title || shareTitle;
  shareDesc = desc || shareDesc;
  shareLink = link || shareLink;
  shareImgUrl = imgUrl || shareImgUrl;
}
/**
 * 分享回调函数列表
 */
let shareCallBackFunList = {
  value: {},
  push: function () {
    if (arguments.length == 1) {
      this.value[new Date().getTime()] = arguments[0];
    } else if (arguments.length == 2) {
      this.value[arguments[0]] = arguments[1];
    }
  },
  remove: function (k) {
    delete this.value[k];
  },
  clear: function () {
    this.value = {};
  }
};
/**
 * 初始化
 * @param {object} options 初始化参数。appid，用来初始化wxjsdk的appid。
 */
 async function init(options) {
  console.log("@/services/act-wxjssdk.js options", options);
  let u = navigator.userAgent;
  let newOptions={...options}
  jssdkObj={...options}
  // 仅在微信环境下获取签名
  console.log('u.toLowerCase().match(/MicroMessenger/i):', u.toLowerCase().match(/MicroMessenger/i))
  console.log(util.browser.versions.wxwork)
   
  if(util.browser.versions.wxwork){
    loadJS('https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js')
    await getWxWorkSignature(newOptions).then(jsParams => {
      console.log('getWxWorkSignature response data:', jsParams)
      wxWorkConfig(jsParams, newOptions);
    })
    await getAgentConfig(newOptions).then(jsParams => {
      console.log('getAgentConfig response data:', jsParams)
      agentConfig(jsParams, newOptions);
    })
  }else if(util.browser.versions.wx)  {

    //之前的逻辑，默认所有用户授权了配置里的主体appId，用户进来都通过配置里的appId去查询用户信息，config=>servicesActWxjssdk
    //取当前url的appId,否则取配置里默认的appId
    let host=window.location.host
    let appid=apiActWxauth.appid
    console.log('获取授权本地url', host);
    console.log('获取授权appid', appid);
    if(appid){
      newOptions.appid = appid;
    }

    getSignature(newOptions).then(jsParams => {
      console.log('getSignature response data:', jsParams)
      wxConfig(jsParams, newOptions);
    })
  }
}

async function upDataInit(options) {

  let u = navigator.userAgent;
  let newOptions={...jssdkObj}
  if(options.appid){
    newOptions.appid = options.appid;
  }
  console.log(newOptions)
  // 仅在微信环境下获取签名
  console.log('u.toLowerCase().match(/MicroMessenger/i):', u.toLowerCase().match(/MicroMessenger/i))
  console.log(util.browser.versions.wxwork)
  if(util.browser.versions.wxwork){
    loadJS('https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js')
    await getWxWorkSignature(newOptions).then(jsParams => {
      console.log('getWxWorkSignature response data:', jsParams)
      wxWorkConfig(jsParams, newOptions);
    })
    await getAgentConfig(newOptions).then(jsParams => {
      console.log('getAgentConfig response data:', jsParams)
      agentConfig(jsParams, newOptions);
    })
  }else if(util.browser.versions.wx)  {
    getSignature(newOptions).then(jsParams => {
      console.log('getSignature response data:', jsParams)
      wxConfig(jsParams, newOptions);
    })
  }
}

function  loadJS( url, callback ){
  var script = document.createElement('script'),
  fn = callback || function(){};
  script.type = 'text/javascript';
  script.onload = function(){
      fn();
  };
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
// 封装的微信ready，如果是非微信环境立马执行
let ready = function (callback) {
  let u = navigator.userAgent;
  if(util.browser.versions.wxwork){
    callback()
  }else if (util.browser.versions.wx) {
    wx.ready(callback);
  }else {
    callback();
  }
}

// 不导出
let shareCallBack = function () {
  Object.keys(shareCallBackFunList.value).forEach(k => {
    shareCallBackFunList.value[k]();
  });
};



// 不导出
function getSignature(options) {
  return new Promise((resolve, reject) => {
    // let site = location.href.split("#/");
    let site = location.origin+location.pathname;
    // if (site.length > 1) {
    //   site = site[0];
    // } else {
    //   site = location.href;
    // }
    let realAppid = apiActWxauth.appid;

    if (options && options.appid) {
      realAppid = options.appid;
    }

    let query = {
      // htmlUrl: encodeURIComponent(site)
      htmlUrl: (site)
    }
    // let url = `${apiActWxauth.protocol}//${realAppid}.${apiActWxauth.domain}${apiActWxauth.action.getSignature}/${realAppid}/${apiActWxauth.openid}?${request.qs.stringify(query)}`;
    let url = `${apiActWxauth.protocol}//${apiActWxauth.domain}${apiActWxauth.action.getSignature}`;
    request.post(
      url, {
      "appId": realAppid,
      "htmlUrl": site
      }
    ).then((res) => {
      if (res && res.data && res.data.data) {
        resolve(res.data.data);
      } else {
        reject(res);
      }
    }).catch((res) => {
      reject(res);
    })
  })
}
// 不导出
function getWxWorkSignature(options) {
  return new Promise((resolve, reject) => {
    let site = location.href.split("#/");
    if (site.length > 1) {
      site = site[0];
    } else {
      site = location.href;
    }
    let realAppid = apiActWxauth.appid;

    if (options && options.appid) {
      realAppid = options.appid;
    }

    // let url = `${apiActWxauth.protocol}//${realAppid}.${apiActWxauth.domain}${apiActWxauth.action.getSignature}/${realAppid}/${apiActWxauth.openid}?${request.qs.stringify(query)}`;
    let url = `${process.env.VUE_APP_WXWORK_API}${apiActWxauth.action.getWxWorkSignature}`;
    request.get(
      url, {
        corpId: Vue.prototype.$corpId ||util.cookie.get('appInfo').corpid ,
        "url": site
      },{
        openId: util.cookie.get('openid')  || '',
        passport: util.cookie.get('passport')  || '',
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    ).then((res) => {
      if (res && res.data && res.data.data) {
        resolve(res.data.data);
      } else {
        reject(res);
      }
    }).catch((res) => {
      reject(res);
    })
  })
}

// 不导出
function wxConfig(jsParams, options) {
  let realAppid = apiActWxauth.appid;
  if (options && options.appid) {
    realAppid = options.appid;
  }
  wx.config({
    debug: false,
    appId: realAppid,
    timestamp: jsParams.timestamp,
    nonceStr: jsParams.nonceStr,
    signature: jsParams.signature,
    
    jsApiList: [
      "checkJsApi",
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareTimeline",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "onMenuShareWeibo",
      'onVoiceRecordEnd',
      "hideMenuItems",
      "showMenuItems",
      "hideAllNonBaseMenuItem",
      "showAllNonBaseMenuItem",
      "translateVoice",
      "startRecord",
      "stopRecord",
      "onRecordEnd",
      "playVoice",
      "pauseVoice",
      "stopVoice",
      "uploadVoice",
      "downloadVoice",
      "chooseImage",
      "previewImage",
      "uploadImage",
      "downloadImage",
      "getNetworkType",
      "openLocation",
      "getLocation",
      "hideOptionMenu",
      "showOptionMenu",
      "closeWindow",
      "scanQRCode",
      "chooseWXPay",
      "openProductSpecificView",
      "addCard",
      "chooseCard",
      "openCard"
    ],
    openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
  });
  wx.ready(function () {
    console.log('wx initial success!')
    // console.log('ready',shareTitle,shareDesc,shareLink,shareImgUrl)
    wx.onMenuShareAppMessage({
    // wx.updateAppMessageShareData({
      // title: 'shareTitle',
      // desc: 'shareDesc',
      // link: 'http://wx01f0b018d4951434.yqyuntech.com/turntable.html#/index?channel=0&actCode=ACT1477509697117786112',
      // imgUrl: 'https://assets-cos-test.yqaitech.com/marcloud/wx01f0b018d4951434/2022102310096935467.png',
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      // type: shareType,
      // dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },
      trigger: function (res) {
        handlerYqAnalyticsEvent("shareAppMessage", {
          platform:'wx',
          link:shareLink
        });
      },
    });
    wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }, 
      trigger: function (res) {
        handlerYqAnalyticsEvent("shareTimeline", {
          platform:'wx',
          link:shareLink
        });
      },
    });
  })
  wx.error(function(res){
    console.log('wx.error:', res)
  })
}
// 不导出
function wxWorkConfig(jsParams, options) {
  window.wx.config({
    beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: Vue.prototype.$corpId ||util.cookie.get('appInfo').corpid , // 必填，企业微信的corpID
    timestamp: jsParams.timestamp, // 必填，生成签名的时间戳
    nonceStr: jsParams.nonce, // 必填，生成签名的随机串
    signature: jsParams.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
    jsApiList: [
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareTimeline",//（即将废弃）
      "onMenuShareAppMessage",//（即将废弃）
      "onMenuShareQQ",//（即将废弃）
      "onMenuShareWeibo",
      "onMenuShareQZone",
      "onMenuShareWechat",
      "startRecord",
      "stopRecord",
      "onVoiceRecordEnd",
      "playVoice",
      "pauseVoice",
      "stopVoice",
      "onVoicePlayEnd",
      "uploadVoice",
      "downloadVoice",
      "chooseImage",
      "previewImage",
      "uploadImage",
      "downloadImage",
      "translateVoice",
      "getNetworkType",
      "openLocation",
      "getLocation",
      "hideOptionMenu",
      "showOptionMenu",
      "hideMenuItems",
      "showMenuItems",
      "hideAllNonBaseMenuItem",
      "showAllNonBaseMenuItem",
      "closeWindow",
      "scanQRCode",
      "chooseWXPay",
      "openProductSpecificView",
      "addCard",
      "chooseCard",
      "openCard",
      "onHistoryBack",
      "setClipboardData"
    ]
  });
  window.wx.ready(function () {
    console.log('wx initial success!')
    console.log(window.jWeixin,window.wx)
    window.wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      success: function () {
        shareCallBack();
      },fail: function (res) {
        console.log(res)
      }, trigger: function (res) {
        handlerYqAnalyticsEvent("onMenuShareAppMessage", {
          platform:'wxWork',
          link:shareLink
        });
      },
    });
    window.wx.onMenuShareWechat({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      success: function () {
        shareCallBack();
      },fail: function (res) {
        console.log(res)
      }, trigger: function (res) {
        handlerYqAnalyticsEvent("onMenuShareWechat", {
          platform:'wxWork',
          link:shareLink
        });
      },
    });
    window.wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },fail: function (res) {
        console.log(res)
      }, trigger: function (res) {
        handlerYqAnalyticsEvent("onMenuShareTimeline", {
          platform:'wxWork',
          link:shareLink
        });
      },
    });
  })
  window.wx.error(function(res){
    console.log('wx.error:', res)
  })
}


// 不导出
function getAgentConfig(options) {
  return new Promise((resolve, reject) => {
    let site = location.href.split("#/");
    if (site.length > 1) {
      site = site[0];
    } else {
      site = location.href;
    }
    let realAppid = apiActWxauth.appid;

    if (options && options.appid) {
      realAppid = options.appid;
    }

    // let url = `${apiActWxauth.protocol}//${realAppid}.${apiActWxauth.domain}${apiActWxauth.action.getSignature}/${realAppid}/${apiActWxauth.openid}?${request.qs.stringify(query)}`;
    let url = `${process.env.VUE_APP_WXWORK_API}${apiActWxauth.action.getCorpAgentSignature}`;
    request.get(
      url, {
        corpId: Vue.prototype.$corpId ||util.cookie.get('appInfo').corpid ,
        "url": site
      },{
        openId: util.cookie.get('openid')  || '',
        passport: util.cookie.get('passport')  || '',
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    ).then((res) => {
      if (res && res.data && res.data.data) {
        resolve(res.data.data);
      } else {
        reject(res);
      }
    }).catch((res) => {
      reject(res);
    })
  })
}
function agentConfig(jsParams){
  console.log(jsParams)
  window.wx.agentConfig({
    agentid: jsParams.agentId, // 必填，企业微信的应用id （e.g. 1000247）
    corpid: Vue.prototype.$corpId ||util.cookie.get('appInfo').corpid , // 必填，企业微信的corpID
    timestamp: jsParams.timestamp, // 必填，生成签名的时间戳
    nonceStr: jsParams.nonce, // 必填，生成签名的随机串
    signature: jsParams.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
    jsApiList: [
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareTimeline",//（即将废弃）
      "onMenuShareAppMessage",//（即将废弃）
      "onMenuShareQQ",//（即将废弃）
      "onMenuShareWeibo",
      "onMenuShareQZone",
      "onMenuShareWechat",
      "startRecord",
      "stopRecord",
      "onVoiceRecordEnd",
      "playVoice",
      "pauseVoice",
      "stopVoice",
      "onVoicePlayEnd",
      "uploadVoice",
      "downloadVoice",
      "chooseImage",
      "previewImage",
      "uploadImage",
      "downloadImage",
      "translateVoice",
      "getNetworkType",
      "openLocation",
      "getLocation",
      "hideOptionMenu",
      "showOptionMenu",
      "hideMenuItems",
      "showMenuItems",
      "hideAllNonBaseMenuItem",
      "showAllNonBaseMenuItem",
      "closeWindow",
      "scanQRCode",
      "chooseWXPay",
      "openProductSpecificView",
      "addCard",
      "chooseCard",
      "openCard",
      "onHistoryBack",
      "setClipboardData"
    ], //必填，传入需要使用的接口名称
	  success: function(res) {
      // 回调
      console.log(res,'agentConfig')
    },
    fail: function(res) {
      console.log(res,jsParams)
        if(res.errMsg.indexOf('function not exist') > -1){
            alert('版本过低请升级')
        }
    }
  });
  
  window.wx.ready(function () {
    console.log('wx agentConfig initial success!')
    console.log(shareTitle,shareDesc,shareLink,shareImgUrl,'agentConfig')
    window.wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      // type: shareType,
      // dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },fail: function (res) {
        console.log(res)
      },trigger: function (res) {
        handlerYqAnalyticsEvent("onMenuShareAppMessage", {
          platform:'wxWork',
          link:shareLink
        });
      },
    });
    window.wx.onMenuShareWechat({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      // type: shareType,
      // dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },fail: function (res) {
        console.log(res)
      },trigger: function (res) {
        handlerYqAnalyticsEvent("onMenuShareWechat", {
          platform:'wxWork',
          link:shareLink
        });
      },
    });
    window.wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },fail: function (res) {
        console.log(res)
      },trigger: function (res) {
        handlerYqAnalyticsEvent("onMenuShareTimeline", {
          platform:'wxWork',
          link:shareLink
        });
      },
    });
  })
  window.wx.error(function(res){
    console.log('wx.error:', res)
  })
}



function getIsInMiniProgram() {
  return new Promise(function (resolve) {
    if (currentIsInMiniProgram == undefined) {
      if (location.href.indexOf("ismp=1") > -1) {
        currentIsInMiniProgram = true;
        resolve(true); //模拟小程序
      }
      if (util.browser.versions.wx) {
        wx.miniProgram.getEnv(function (res) {
          currentIsInMiniProgram = res.miniprogram;
          resolve(res.miniprogram);
        });
      } else {
        currentIsInMiniProgram = false;
        resolve(false);
      }
    } else {
      resolve(currentIsInMiniProgram);
    }
  })
}

function getLocation(type='gcj02') {
  return new Promise(function (resolve) {
    wx.getLocation({
      type: type, // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        console.log(res)
        resolve(res)
      },
      fail: function (err) {
        // MessageBox.alert(JSON.stringify(err)).then(() => {
        console.log(err)
        // yqAnalytics.clientLog('获取位置异常', err)
        // MessageBox.alert('获取位置异常请刷新重试').then(() => {
        //     wx.closeWindow();
        // })
      }
    });
  })
}

function scanQRCode(){
  
  return new Promise(function (resolve) {
    wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
            resolve(res)
        },
        fail: function(error) {
          console.log(error)
            MessageBox(JSON.stringify(error)).then(() => {
                wx.closeWindow();
            })
        },
        complete: function(res) {
          console.log(JSON.stringify(res));
        }
    });
})
}

function hideOptionMenu(){
  wx.ready(function() {
    wx.hideOptionMenu();
  });
}

function upShare(title,desc,link,imgUrl) {
    console.log('upData',title,desc,link,imgUrl)
    shareTitle=title
    shareDesc=desc
    shareLink=link
    shareImgUrl=imgUrl
  wx.ready(function () {
    wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },
    });
    wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }
    });
    // wx.updateTimelineShareData({
    //   title: shareTitle,
    //   desc: shareDesc,
    //   link: shareLink,
    //   imgUrl: shareImgUrl,
    //   type: shareType,
    //   dataUrl: shareDataUrl,
    //   success: function () {
    //     shareCallBack();
    //   }
    // });
  })
}
function upWxWorkShare(title,desc,link,imgUrl) {
  console.log('upWxWorkShare',title,desc,link,imgUrl)
  shareTitle=title
  shareDesc=desc
  shareLink=link
  shareImgUrl=imgUrl
  console.log(window.jWeixin,window.wx)
  window.wx.ready(function () {
    window.wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      },
    });
    window.wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }
    });
    // wx.updateTimelineShareData({
    //   title: shareTitle,
    //   desc: shareDesc,
    //   link: shareLink,
    //   imgUrl: shareImgUrl,
    //   type: shareType,
    //   dataUrl: shareDataUrl,
    //   success: function () {
    //     shareCallBack();
    //   }
    // });
  })
}
async function isNeedUpdate(){
  let url = apizt.action.getShareAppId;
  const { data, result } = await httpzt.requestRestFul(url, {});
  console.log(data)
  if(result){
    if(data!=jssdkObj.appid){
      this.upDataInit({
        appid:data
      })
    }
  }
}


export default {
  sdk: wx,
  shareTitle,
  shareDesc,
  shareLink,
  shareImgUrl,
  shareType,
  shareDataUrl,
  shareCallBackFunList,
  init,
  setShare,
  ready,
  getIsInMiniProgram,
  getLocation,
  upShare,
  upWxWorkShare,
  hideOptionMenu,
  scanQRCode,
  upDataInit,//更新sdk公众号
  isNeedUpdate,//更新sdk公众号
}